/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getProductValueTransferSnapshot} from '../api'

 export const useQueryGetProductValueTransferSnapshot = createReactQueryHook('getProductValueTransferSnapshot', getProductValueTransferSnapshot)
